import React from 'react'
import { STATICS } from 'statics'
import { Button } from 'components/button'
import { sendWhatsappMessage } from 'utils'
import './style.scss'

export function Clerk() {
  function handleOnclick() {
    sendWhatsappMessage({})
  }

  return (
    <div className='container-clerk'>
      <div className='container-image'>
        <STATICS.INFO_CIRCLE />
      </div>
      <div className='container-info'>
        <span className='text'>
          Identificamos uma falha no equipamento que está impedindo a configuração do Wi-Fi pelo
          site.{' '}
        </span>
        <span className='text'>
          Podemos te ajudar com isso! Toque no botão abaixo para falar com nosso atendimento
          <strong> informe seu CPF e, em seguida, siga o caminho:</strong>
        </span>
        <span className='text path'>
          Suporte {'>'} Internet {'>'} Wi-Fi
        </span>
      </div>
      <div className='container-buttons'>
        <Button color='primary' className='button' onClick={handleOnclick}>
          Falar com atendimento
        </Button>
      </div>
    </div>
  )
}
